import { lazy } from 'react';
import { getCorrespondLabel } from '@/utils/global';
const ExamRoutes = [
    {
        label: '去' + getCorrespondLabel('102'),
        key: 'do-exam',
        path: '/exam',
        element: lazy(() => import('@/page/Exam')),
        needJudgeRealName: true,
        realNameType: 'exam'
    },
    {
        label: '查看考试或作业解析',
        key: 'exam-analysis',
        path: '/examAnalysis/:id',
        element: lazy(() => import('@/page/Exam/Analysis')),
        needJudgeRealName: true,
        realNameType: 'exam'
    },
    {
        label: '做作业',
        key: 'do-practise',
        path: '/practise',
        element: lazy(() => import('@/page/homeWork')),
        needJudgeRealName: true,
        realNameType: 'practise'
    },
    {
        label: getCorrespondLabel('106') + '作答',
        key: 'do-researchresult',
        path: '/researchResult',
        element: lazy(() => import('@/page/researchresult')),
        needJudgeRealName: true,
        realNameType: 'researchResult'
    },
    {
        label: getCorrespondLabel('106') + '解析',
        key: 'researchResultAnalysis',
        path: '/researchResultAnalysis/:id',
        element: lazy(() => import('@/page/researchresult/Analysis')),
        needJudgeRealName: true,
        realNameType: 'exam'
    },
    {
        label: '活动首页',
        key: 'activity-detail',
        show: true,
        path: '/:template_id/:businessId/:state/activityDetail',
        element: lazy(() => import('@/page/Activity/Home/index')),
        needJudgeRealName: true,
        realNameType: 'activity'
    },
    {
        label: '活动成绩',
        key: 'activity-achievement',
        show: true,
        path: '/:template_id/:businessId/:state/achievement',
        element: lazy(() => import('@/page/Activity/Home/achievement'))
    },
    {
        label: '公告详情',
        key: 'notice-detail',
        show: true,
        path: '/:template_id/:business_id/notice-detail',
        element: lazy(() => import('@/page/Project/Notice/NoticeDetail')),
        realNameType: 'notice-detail'
    },
    {
        label: '公告详情-开放课',
        key: 'notice-detail-opencourse',
        show: true,
        path: '/:template_id/:business_id/notice-detail-opencourse',
        element: lazy(() => import('@/page/TeachBusiness/components/Notice/NoticeDetail')),
        needJudgeRealName: true,
        realNameType: 'notice-detail'
    },
    {
        label: '预览',
        key: 'do-preview',
        path: '/public/preview',
        element: lazy(() => import('@/page/Exam/preview/index.jsx'))
    }
];
export default ExamRoutes;
